import Vue from "vue";
import VueRouter from "vue-router";
import ROUTE from "~/constants/routes";
import { getStoredUserInfo } from "../helpers/userAuth";

const Login = () => import("~/pages/Login.vue");
// const Registration = () => import("~/pages/Registration.vue");
const Home = () => import("~/pages/Home.vue");

const PageNotFound = () => import("~/pages/error/PageNotFound.vue");

const LeadList = () => import("~/pages/lead/list.vue");
const LeadUTMList = () => import("~/pages/lead/list-utm.vue");
const LeadHistoryList = () => import("~/pages/lead/list-history.vue");
const LeadDepositList = () => import("~/pages/lead/list-deposit.vue");
const LeadForm = () => import("~/pages/lead/form.vue");
const LeadJobs = () => import("~/pages/lead/list-jobs.vue");

const UserList = () => import("~/pages/user/list.vue");
const UserCreate = () => import("~/pages/user/create.vue");
const UserEdit = () => import("~/pages/user/edit.vue");

const BuyerDeposit = () => import("~/pages/user/buyer-deposit.vue");
const CompaignReport = () => import("~/pages/user/compaign.vue");
const CountryDeposit = () => import("~/pages/user/country-deposit.vue");

const SpendingList = () => import("~/pages/spending/list.vue");
const CountryList = () => import("~/pages/country/list.vue");

const TeamList = () => import("~/pages/team/list.vue");
const TeamCreate = () => import("~/pages/team/create.vue");
const TeamEdit = () => import("~/pages/team/edit.vue");
const TeamDetail = () => import("~/pages/team/detail.vue");

const ClientList = () => import("~/pages/client/list.vue");
const ClientCreate = () => import("~/pages/client/create.vue");
const ClientEdit = () => import("~/pages/client/edit.vue");

const IntegrationList = () => import("~/pages/integration/list.vue");
const IntegrationHistoryList = () => import("~/pages/integration/list-history.vue");
const IntegrationCreate = () => import("~/pages/integration/create.vue");
const IntegrationEdit = () => import("~/pages/integration/edit.vue");
const IntegrationResponses = () => import("~/pages/integration/list-responses.vue");

const LogList = () => import("~/pages/log/list.vue");

const Static = () => import("~/pages/static/index.vue");
const BayerInfo = () => import("~/pages/static/bayer-info.vue");
const TelegramList = () => import("~/pages/lead/list-telegram.vue");
const TelegramListRec = () => import("~/pages/lead/list-telegram-rec.vue");

Vue.use(VueRouter);

const checkPrivateRoute = (to, from, next) => {
  if (getStoredUserInfo() === null) return next(ROUTE.LOGIN_PAGE);
  return next();
};

// Группы, которые меню считает админскими (NavigationMenuLinks). Остальные страницы
// роль в роутере не проверяют вовсе, но ответы партнёров открыты только админу —
// проверяем и здесь, чтобы страница не открывалась по прямой ссылке.
// Раздел «Ответы партнёров»: заказчик сказал «админу доступ только», и бэкенд
// закрыт check.permission:Admin. Общая конвенция [2, 5, 6] сюда не годится:
// Head и Shift увидели бы раздел и получили 403 при загрузке.
const ADMIN_GROUP_IDS = [2];

const checkAdminRoute = (to, from, next) => {
  const user = getStoredUserInfo();

  if (user === null) return next(ROUTE.LOGIN_PAGE);

  const groupId = user.groups && user.groups.length ? user.groups[0].id : null;

  if (!ADMIN_GROUP_IDS.includes(groupId)) return next(ROUTE.HOME_PAGE);

  return next();
};

const routes = [
  {
    path: ROUTE.LOGIN_PAGE,
    name: "Login",
    component: Login,
  },

  // Home page

  {
    path: ROUTE.HOME_PAGE,
    name: "HOME",
    component: Home,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Lead Pages

  {
    path: ROUTE.LEAD_LIST,
    name: "LeadList",
    component: LeadList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.LEAD_UTM,
    name: "LeadUTMList",
    component: LeadUTMList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.LEAD_HISTORY,
    name: "LeadHistoryList",
    component: LeadHistoryList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.LEAD_DEPOSIT,
    name: "LeadDepositList",
    component: LeadDepositList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.LEAD_FORM,
    name: "LeadForm",
    component: LeadForm,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.LEAD_JOBS,
    name: "LeadJobs",
    component: LeadJobs,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Client Pages

  {
    path: ROUTE.CLIENT_LIST,
    name: "ClientList",
    component: ClientList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.CLIENT_CREATE,
    name: "ClientCreate",
    component: ClientCreate,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.CLIENT_EDIT,
    name: "ClientEdit",
    component: ClientEdit,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Users Pages

  {
    path: ROUTE.USER_LIST,
    name: "UserList",
    component: UserList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.USER_CREATE,
    name: "UserCreate",
    component: UserCreate,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.USER_EDIT,
    name: "UserEdit",
    component: UserEdit,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.BUYER_DEPOSIT,
    name: "BuyerDeposit",
    component: BuyerDeposit,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.COUNTRY_DEPOSIT,
    name: "CountryDeposit",
    component: CountryDeposit,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.COMPAIGN_REPORT,
    name: "CompaignReport",
    component: CompaignReport,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Spending

  {
    path: ROUTE.SPENDING_LIST,
    name: "SpendingList",
    component: SpendingList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Team Pages

  {
    path: ROUTE.TEAM_LIST,
    name: "TeamList",
    component: TeamList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.TEAM_CREATE,
    name: "TeamCreate",
    component: TeamCreate,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.TEAM_EDIT,
    name: "TeamEdit",
    component: TeamEdit,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.TEAM_DETAIL,
    name: "TeamDetail",
    component: TeamDetail,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Integration Pages

  {
    path: ROUTE.INTEGRATION_LIST,
    name: "IntegrationList",
    component: IntegrationList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.INTEGRATION_HISTORY,
    name: "IntegrationHistoryList",
    component: IntegrationHistoryList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.INTEGRATION_RESPONSES,
    name: "IntegrationResponses",
    component: IntegrationResponses,
    beforeEnter: (to, from, next) => {
      checkAdminRoute(to, from, next);
    },
  },
  {
    path: ROUTE.INTEGRATION_CREATE,
    name: "IntegrationCreate",
    component: IntegrationCreate,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },
  {
    path: ROUTE.INTEGRATION_EDIT,
    name: "IntegrationEdit",
    component: IntegrationEdit,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Log Pages

  {
    path: ROUTE.LOG,
    name: "LogList",
    component: LogList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.COUNTRY_LIST,
    name: "CountryList",
    component: CountryList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // Static Page

  {
    path: ROUTE.STATIC,
    name: "Static",
    component: Static,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.BAYER_INFO,
    name: "BayerInfo",
    component: BayerInfo,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.TELEGRAM_FILTER,
    name: "TelegramList",
    component: TelegramList,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  {
    path: ROUTE.TELEGRAM_RECONCILIATION,
    name: "TelegramListRec",
    component: TelegramListRec,
    beforeEnter: (to, from, next) => {
      checkPrivateRoute(to, from, next);
    },
  },

  // 404 routes

  {
    path: "*",
    name: "PageNotFound",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",

  base: process.env.BASE_URL,

  routes,
});

export default router;
